import {Component, OnInit} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {ArrayDataSource} from '@angular/cdk/collections';
import {NestedTreeControl} from '@angular/cdk/tree';

@Component({
    selector: 'md-page-builder-datasource-picker',
    templateUrl: './md-page-builder-datasource-picker.component.html',
    styleUrls: ['./md-page-builder-datasource-picker.component.scss']
})
export class MDPageBuilderDatasourcePickerComponent implements OnInit {
    treeControl = new NestedTreeControl<any> (node => node.children);
    dataSource = new ArrayDataSource([
        {
          name: 'Fruit',
          children: [
            {name: 'Apple'},
            {name: 'Banana'},
            {name: 'Fruit loops'},
          ]
        }, {
          name: 'Vegetables',
          children: [
            {
              name: 'Green',
              children: [
                {name: 'Broccoli'},
                {name: 'Brussels sprouts'},
              ]
            }, {
              name: 'Orange',
              children: [
                {name: 'Pumpkins'},
                {name: 'Carrots'},
              ]
            },
          ]
        },
    ]);

    constructor(
        private dialogRef: MatDialogRef<MDPageBuilderDatasourcePickerComponent>
    ) {
    }

    ngOnInit() {
    }

    onClose() {
        this.dialogRef.close();
    }

    hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;
}